import { makeHttpRequest } from "@/shared";

import { mapCalculatedRentFromServer } from "./mappers/mapCalculatedRentFromServer";
import { mapRentInventoryToServer } from "./mappers/mapRentInventoryToServer";

export const finishRentInventory = async (sessionKey, rentInventory) => {
    const response = (
        await makeHttpRequest({
            url: `/rent/builder/${sessionKey}/inventory/finish`,
            method: "PUT",
            data: mapRentInventoryToServer(rentInventory),
        })
    ).data;

    return mapCalculatedRentFromServer(response.data);
};
